import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

function Stat({ label, value, testid }) {
    return (
        <div className="border-2 border-[hsl(var(--ink))] bg-card p-6" data-testid={testid}>
            <div className="font-mono-brand text-[10px] uppercase tracking-wider text-[hsl(var(--ink-soft))]">{label}</div>
            <div className="mt-2 font-display text-4xl text-[hsl(var(--ink))]">{value}</div>
        </div>
    );
}

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);
    useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)); }, []);
    return (
        <div data-testid="admin-dashboard">
            <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Overview</div>
            <h1 className="mt-2 font-display text-4xl uppercase italic text-[hsl(var(--ink))]">Dashboard</h1>
            {stats && (
                <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    <Stat label="Products" value={stats.products} testid="stat-products" />
                    <Stat label="Orders (paid)" value={`${stats.orders_paid} / ${stats.orders}`} testid="stat-orders" />
                    <Stat label="Revenue (USD)" value={`$${(stats.revenue || 0).toFixed(2)}`} testid="stat-revenue" />
                    <Stat label="Users" value={stats.users} testid="stat-users" />
                    <Stat label="Contact msgs" value={stats.contacts} testid="stat-contacts" />
                    <Stat label="Bookings" value={stats.bookings} testid="stat-bookings" />
                    <Stat label="Build Club" value={stats.build_club || 0} testid="stat-build-club" />
                </div>
            )}
            <div className="mt-10 grid gap-4 md:grid-cols-2">
                <Link to="/admin/products" className="border border-[hsl(var(--dust-300))] bg-card p-6 transition-transform hover:-translate-y-0.5">
                    <div className="font-heading text-lg uppercase text-[hsl(var(--ink))]">Manage catalog →</div>
                    <p className="mt-2 text-sm text-[hsl(var(--ink-soft))]">Add, edit, or hide parts.</p>
                </Link>
                <Link to="/admin/orders" className="border border-[hsl(var(--dust-300))] bg-card p-6 transition-transform hover:-translate-y-0.5">
                    <div className="font-heading text-lg uppercase text-[hsl(var(--ink))]">Recent orders →</div>
                    <p className="mt-2 text-sm text-[hsl(var(--ink-soft))]">Check payment status and fulfill.</p>
                </Link>
            </div>
        </div>
    );
}
